import AddIcon from "@mui/icons-material/Add";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import {
  Box,
  Card,
  Grid,
  Step,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import SortableList, { SortableItem } from "react-easy-sort";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../components/CustomButton";
import CustomCheckbox from "../../../components/CustomCheckbox";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import CustomSelect from "../../../components/Select/Select";
import { getClinicStocks } from "../../../redux/reducers/clinicSlice";
import {
  createTreatmentPlan,
  getTreatmentPlans,
} from "../../../redux/reducers/planSlice";
import { AppColors } from "../../../util/AppColors";
import { frequncyCheckList } from "../../../util/arrayList";
import {
  answerTypes,
  mealTypes,
  petAppntTypeList,
  petTypes,
  planServiceTypes,
  typeList,
} from "../../../util/dropList";

const initObject = { question: "", questionType: null, isRequired: false };
const card = {
  borderRadius: 1,
  paddingLeft: 2,
  paddingRight: 2,
  paddingTop: 1,
  paddingBottom: 1,
  borderTopColor: AppColors.appPrimary,
  marginLeft: 0,
  marginRight: 0,
};
const icon = { width: 30, height: 30, color: AppColors.appPrimary };
const plusBtn = { color: AppColors.appPrimary, width: 15, height: 15 };
const initPres = {
  name: "",
  qty: "1",
  dosage: "",
  duration: "",
  frequency: null,
  meal: null,
};
const requiredFields = [
  "planName",
  "species",
  "serviceType",
  "consultationType",
  "type",
  "estimatedDuration",
];

const TreatmentPlanCreate = ({
  setCreateVsble,
  selectedPlan,
  setSelectedPlan,
}) => {
  const dispatch = useDispatch();
  const [activeStep, setActiveStep] = useState(0);
  const [planValues, setPlanValues] = useState({});
  const [planErrs, setPlanErrs] = useState({});
  const [planHlps, setPlanHlps] = useState({});
  const [questions, setQuestions] = useState([initObject]);
  const [presOpen, setPresOpen] = useState(true);
  const [presList, setPresList] = useState([]);
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);

  useEffect(() => {
    dispatch(getClinicStocks());
  }, []);

  const handleChange = (name, value) => {
    setPlanValues({ ...planValues, [name]: value });
    setPlanErrs({
      ...planErrs,
      [name]:
        value?.length > 0
          ? false
          : requiredFields?.find((fld) => fld === name)
          ? true
          : false,
    });
    setPlanHlps({
      ...planHlps,
      [name]:
        value?.length > 0
          ? ""
          : requiredFields?.find((fld) => fld === name)
          ? "This field is required"
          : "",
    });
  };

  const moveArrayElement = (array, fromIndex, toIndex) => {
    const updatedArray = [...array];
    const [movedItem] = updatedArray.splice(fromIndex, 1); // Remove the item from the old index
    updatedArray.splice(toIndex, 0, movedItem); // Insert it at the new index
    return updatedArray;
  };

  const onSortEnd = (oldIndex, newIndex) => {
    setQuestions((array) => moveArrayElement(array, oldIndex, newIndex));
  };

  const handleChildSort = (parentIndex, fromIndex, toIndex) => {
    const reqAray = questions?.map((li, i) => {
      if (i === parentIndex) {
        const reqAnswers = [...li?.answers];
        const [movedItem] = reqAnswers.splice(fromIndex, 1); // Remove the item from the old index
        reqAnswers.splice(toIndex, 0, movedItem); // Insert it at the new index
        return { ...li, answers: reqAnswers };
      }
      return li;
    });
    setQuestions(reqAray);
  };

  const handleChangeValue = (name, value, ind) => {
    const reqList = questions?.map((li, i) => {
      if (i === ind) {
        const reqObj = { ...li, [name]: value };
        if (
          value === "multipleChoice" ||
          value === "checkboxes" ||
          value === "fileupload"
        ) {
          reqObj.answers = [value === "fileupload" ? "file" : ""];
        }
        if (value === "shortAnswer" || value === "paragraph") {
          reqObj.answer = "";
        }
        return reqObj;
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleChangeAnswer = (mainInd, secInd, value) => {
    const reqList = questions?.map((li, i) => {
      if (i === mainInd) {
        const reqArr = li?.answers?.map((ans, ind) => {
          if (ind === secInd) return value;
          return ans;
        });
        return { ...li, answers: reqArr };
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleAddQuestion = () => {
    setQuestions((prev) => [...prev, initObject]);
  };

  const handleDeleteQuestion = (ind) => {
    if (questions?.length > 1) {
      const reqList = questions?.filter((li, i) => i !== ind);
      setQuestions(reqList);
    }
  };

  const handleBackClick = () => {
    dispatch(getTreatmentPlans());
    setPlanValues({});
    setCreateVsble(false);
    setSelectedPlan(null);
    setActiveStep(0);
  };

  const handleAddAnswer = (ind) => {
    const reqList = questions?.map((li, i) => {
      if (i === ind) {
        return { ...li, answers: [...li?.answers, ""] };
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleDeleteAnswer = (mainInd, secInd) => {
    const reqList = questions?.map((li, i) => {
      if (i === mainInd) {
        const reqArr = li?.answers?.filter((ans, ind) => ind !== secInd);
        return { ...li, answers: reqArr };
      }
      return li;
    });
    setQuestions(reqList);
  };

  const handleNext = () => {
    let errs = {};
    let hlps = {};
    requiredFields?.forEach((fld) => {
      const reqValue = planValues?.[fld];
      if (!reqValue || reqValue?.length === 0) {
        errs = { ...errs, [fld]: true };
        hlps = { ...hlps, [fld]: "This is field is required" };
      }
    });
    setPlanErrs(errs);
    setPlanHlps(hlps);
    if (Object.keys(errs)?.length > 0) return;
    if (
      questions?.length === 0 ||
      questions?.some((li) => li?.question?.length === 0 || !li?.questionType)
    )
      return;
    setActiveStep(activeStep + 1);
  };

  const handlePresOpen = () => {
    setPresOpen(!presOpen);
  };

  const handleAddItem = () => {
    setPresList((prev) => [...prev, { ...initPres, i: prev?.length }]);
  };

  const getListBySelectedType = () => {
    const reqList = stocks?.data?.filter((dta) => {
      return (
        (dta?.category?.toLowerCase() === "medication" ||
          dta?.category?.toLowerCase() === "diet" ||
          dta?.category?.toLowerCase() === "nutrition and supplements") &&
        dta?.stockBatch?.find(
          (btch) => btch?.billlable === "Y" && btch?.quantity > 0
        )
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      type: li?.category,
    }));
  };

  const handleChangePresValue = (name, value, ind, addObj) => {
    const reqList = presList?.map((pl, i) => {
      if (i === ind) {
        const reqObj = { ...pl, [name]: value };
        if (name === "frequency") {
          if (value?.includes("Custom")) {
            reqObj.frequency = "";
            reqObj.customFrequency = true;
          }
        }
        if (name === "name" && addObj) {
          reqObj.type = addObj?.type;
          reqObj.stockId = addObj?.stockId;
          reqObj.cost = getBatchList(addObj?.stockId)?.[0]?.unitSellingPrice;
        }
        if (name === "qty") {
          if (pl?.stockId && Number(value) > 0) {
            reqObj.cost =
              getBatchList(pl?.stockId)?.[0]?.unitSellingPrice * Number(value);
          } else {
            reqObj.cost = 0;
          }
        }
        if (name === "type") reqObj.name = null;
        if (addObj?.productId) {
          reqObj.productId = addObj?.productId;
        }
        if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
        return reqObj;
      }
      return pl;
    });
    setPresList(reqList);
  };

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    if (!reqStock) return [];
    const filteredBatches = reqStock?.stockBatch
      ?.filter((btch) => btch?.billlable === "Y" && btch?.quantity > 0)
      ?.map((btch) => ({
        name: btch?.batchNo,
        value: btch?.batchNo,
        batchId: btch?.batchId,
        salesUom: btch?.salesUom,
        unitSellingPrice: btch?.unitSellingPrice,
      }));
    return filteredBatches;
  };

  const deletePresByIndex = (ind) => {
    const reqList = presList
      .filter((pre, i) => {
        return i !== ind;
      })
      ?.map((rl, i) => ({ ...rl, i }));
    setPresList(reqList);
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleSkip = () => {
    setActiveStep(activeStep + 1);
  };

  const handleSubmit = () => {
    const question = questions?.map((ques) => {
      const reqObj = {
        // day: 1,
        question: ques?.question,
        questionType: ques?.questionType,
        required: ques?.isRequired,
      };
      if (
        ques?.questionType === "shortAnswer" ||
        ques?.questionType === "paragraph"
      ) {
        reqObj.answer = [ques?.answer];
      }
      if (
        ques?.questionType === "multipleChoice" ||
        ques?.questionType === "checkboxes"
      ) {
        reqObj.answer = ques?.answers;
      }
      if (ques?.questionType === "fileupload") {
        reqObj.answer = ques?.answers;
      }
      return reqObj;
    });
    let treatmentPrescription = [];
    if (presList?.length > 0) {
      treatmentPrescription = presList?.map((pre) => {
        const reqObj = {
          administered: "Prescribed",
          type: pre?.type ?? null,
          stockId: pre?.stockId,
          batchId: getBatchList(pre?.stockId)?.[0]?.batchId ?? null,
          name: pre?.name,
          dosage: pre?.dosage,
          duration: pre?.duration,
          meal: pre?.meal,
          quantity: typeof pre?.qty === "undefined" ? 1 : Number(pre?.qty),
          subUnit: "Unit",
          morning:
            (pre?.frequency?.includes("morning") &&
              !pre?.frequency?.includes("Custom")) ??
            false,
          afternoon:
            (pre?.frequency?.includes("afternoon") &&
              !pre?.frequency?.includes("Custom")) ??
            false,
          night:
            (pre?.frequency?.includes("night") &&
              !pre?.frequency?.includes("Custom")) ??
            false,
          adminChargeAmount: 0,
          adminCharge: "N",
          percentage: false,
        };
        if (typeof pre?.frequency === "string") {
          reqObj.frequencyDuration = pre?.frequency;
        }
        return reqObj;
      });
    }
    const data = {
      planName: planValues?.planName,
      species: planValues?.species,
      serviceType: planValues?.serviceType,
      consulationType: planValues?.consultationType,
      type: planValues?.type,
      estimatedDuration: `${planValues?.estimatedDuration} ${
        planValues?.type === "Outpatient" ? "mins" : "days"
      }`,
      description: planValues?.description,
      question,
      treatmentPrescription,
    };
    dispatch(createTreatmentPlan(data)).then((res) => {
      if (res?.payload) handleBackClick();
    });
  };

  return (
    <>
      <div className="ml50 cursor mt10" onClick={handleBackClick}>
        <div className="flex-row-ali-cen">
          <ArrowBackIosIcon
            sx={{ color: AppColors.appPrimary, width: 20, height: 20 }}
          />
          <Typography className="fs16 txt-semi-bold blue-color ml5">
            Back
          </Typography>
        </div>
      </div>
      <Grid container spacing={0} className="flex-center mt20">
        <Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
          <Box sx={{ width: "100%" }} className="mb20">
            <Stepper activeStep={activeStep}>
              {["1", "2", "3"].map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                return (
                  <Step key={label + index} {...stepProps}>
                    <StepLabel {...labelProps} />
                  </Step>
                );
              })}
            </Stepper>
          </Box>
        </Grid>
        <Grid item xs={12} sm={12} md={10} lg={10} xl={10}>
          <div className="scroll-70vh pr10 pb30">
            {activeStep === 0 ? (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Plan Name <span className="red-color">*</span>
                    </div>
                    <CustomTextField
                      value={planValues?.planName}
                      handleChange={(e) =>
                        handleChange("planName", e?.target?.value)
                      }
                      fullWidth
                      error={planErrs?.planName}
                      helperText={planHlps?.planName}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Species <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={petTypes}
                      value={planValues?.species ?? []}
                      handleChange={(e) =>
                        handleChange("species", e?.target?.value)
                      }
                      multiSelectTagCheck
                      error={planErrs?.species}
                      helperText={planHlps?.species}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Service Type <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={planServiceTypes}
                      value={planValues?.serviceType}
                      handleChange={(e) =>
                        handleChange("serviceType", e?.target?.value)
                      }
                      select
                      error={planErrs?.serviceType}
                      helperText={planHlps?.serviceType}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Consultation Type <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={typeList}
                      value={planValues?.consultationType ?? []}
                      handleChange={(e) =>
                        handleChange("consultationType", e?.target?.value)
                      }
                      multiSelectTagCheck
                      error={planErrs?.consultationType}
                      helperText={planHlps?.consultationType}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Type <span className="red-color">*</span>
                    </div>
                    <CustomSelect
                      list={petAppntTypeList}
                      value={planValues?.type}
                      handleChange={(e) =>
                        handleChange("type", e?.target?.value)
                      }
                      select
                      error={planErrs?.type}
                      helperText={planHlps?.type}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Estimated Duration <span className="red-color">*</span>
                    </div>
                    <CustomTextField
                      fullWidth
                      handleChange={(e) =>
                        handleChange("estimatedDuration", e?.target?.value)
                      }
                      value={planValues?.estimatedDuration}
                      endIcon
                      inputIcon={
                        planValues?.type === "Inpatient" ? "Days" : "Mins"
                      }
                      error={planErrs?.estimatedDuration}
                      helperText={planHlps?.estimatedDuration}
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Description
                    </div>
                    <CustomTextField
                      value={planValues?.description}
                      handleChange={(e) =>
                        handleChange("description", e?.target?.value)
                      }
                      fullWidth
                      multiline
                    />
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="flex-center fs24 font-medium blue-color">
                      Custom Treatment Protocol Form
                    </Typography>
                  </Grid>
                </Grid>
                <SortableList
                  onSortEnd={onSortEnd}
                  className="parent-list"
                  dragHandleSelector=".parent-drag-handle"
                  tag="div"
                >
                  {questions?.map((ques, i) => {
                    return (
                      <SortableItem key={`${i}-parent`}>
                        <Grid container spacing={1} className="mt10">
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <Typography className="fs16 blue-color font-medium">
                              Question {i + 1}
                            </Typography>
                          </Grid>
                          <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                            <CustomTextField
                              fullWidth
                              handleChange={(e) =>
                                handleChangeValue(
                                  "question",
                                  e?.target?.value,
                                  i
                                )
                              }
                              value={ques?.question}
                              placeholder="Type question here"
                            />
                          </Grid>
                          <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
                            <CustomSelect
                              list={answerTypes}
                              value={ques?.questionType}
                              handleChange={(e) =>
                                handleChangeValue(
                                  "questionType",
                                  e?.target?.value,
                                  i
                                )
                              }
                              select
                            />
                          </Grid>
                          {ques?.questionType === "shortAnswer" ||
                          ques?.questionType === "paragraph" ? (
                            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                              <CustomTextField
                                fullWidth
                                handleChange={(e) =>
                                  handleChangeValue(
                                    "answer",
                                    e?.target?.value,
                                    i
                                  )
                                }
                                value={ques?.answer}
                                placeholder="Enter Answer"
                                multiline={ques?.questionType === "paragraph"}
                              />
                            </Grid>
                          ) : ques?.questionType === "multipleChoice" ||
                            ques?.questionType === "checkboxes" ? (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              <SortableList
                                className="child-list"
                                onSortEnd={(oldIndex, newIndex) =>
                                  handleChildSort(i, oldIndex, newIndex)
                                }
                                dragHandleSelector=".child-drag-handle"
                                tag="div"
                              >
                                {ques?.answers?.map((ans, ind) => (
                                  <SortableItem key={`${ind}-child`}>
                                    <div
                                      className="flex-row-ali-cen"
                                      onPointerDown={(e) => e.stopPropagation()}
                                    >
                                      <div className="ml10">
                                        <CustomCheckbox
                                          value={false}
                                          circle={
                                            ques?.questionType ===
                                            "multipleChoice"
                                          }
                                        />
                                      </div>
                                      <div className="w60Per">
                                        <CustomTextField
                                          value={ans}
                                          fullWidth
                                          handleChange={(e) =>
                                            handleChangeAnswer(
                                              i,
                                              ind,
                                              e?.target?.value
                                            )
                                          }
                                        />
                                      </div>
                                      {ques?.answers?.length === ind + 1 ? (
                                        <img
                                          src={require("../../../assets/images/png/plusGry.png")}
                                          className="img-wh20 ml10 cursor"
                                          onClick={() => handleAddAnswer(i)}
                                        />
                                      ) : null}
                                      {ques?.answers?.length > 1 ? (
                                        <img
                                          src={require("../../../assets/images/png/delGry.png")}
                                          className="img-wh20 ml10 cursor"
                                          onClick={() =>
                                            handleDeleteAnswer(i, ind)
                                          }
                                        />
                                      ) : null}
                                      <div className="cursor">
                                        <span className="child-drag-handle">
                                          ☰
                                        </span>
                                      </div>
                                    </div>
                                  </SortableItem>
                                ))}
                              </SortableList>
                            </Grid>
                          ) : (
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                              {ques?.answers?.map((_, ind) => (
                                <div
                                  className={`flex-row-ali-cen ${
                                    ind > 0 ? "mt10" : ""
                                  }`}
                                  key={`${ind} file`}
                                >
                                  <div>
                                    <CustomButton
                                      smallBtn
                                      text="Upload File"
                                      grayBtn
                                      disabled
                                    />
                                  </div>
                                  {ques?.answers?.length === ind + 1 ? (
                                    <img
                                      src={require("../../../assets/images/png/plusGry.png")}
                                      className="img-wh20 ml10 cursor"
                                      onClick={() => handleAddAnswer(i)}
                                    />
                                  ) : null}
                                  {ques?.answers?.length > 1 ? (
                                    <img
                                      src={require("../../../assets/images/png/delGry.png")}
                                      className="img-wh20 ml10 cursor"
                                      onClick={() => handleDeleteAnswer(i, ind)}
                                    />
                                  ) : null}
                                </div>
                              ))}
                            </Grid>
                          )}
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div className="flex-row-between-align-center mt10">
                              <div className="flex-row-ali-cen">
                                <div className="cursor">
                                  <span className="parent-drag-handle">☰</span>
                                </div>
                                <img
                                  src={require("../../../assets/images/png/del.png")}
                                  className="img-wh20 cursor ml10"
                                  onClick={() => handleDeleteQuestion(i)}
                                />
                                <div
                                  className="flex-row-ali-cen cursor ml10"
                                  onClick={handleAddQuestion}
                                >
                                  <div className="flex-center plus-icon">
                                    <AddIcon
                                      sx={{
                                        color: AppColors.appPrimary,
                                        width: 15,
                                        height: 15,
                                      }}
                                    />
                                  </div>
                                  <Typography className="blue-color fs16 ml5 font-bold">
                                    Add
                                  </Typography>
                                </div>
                              </div>
                              <div className="pr10 flex-center">
                                <CustomSwitch
                                  value={ques?.isRequired}
                                  onChange={(e) =>
                                    handleChangeValue(
                                      "isRequired",
                                      e?.target?.value,
                                      i
                                    )
                                  }
                                  grayToBlue
                                />
                              </div>
                            </div>
                          </Grid>
                        </Grid>
                      </SortableItem>
                    );
                  })}
                </SortableList>
                <div className="flex-end mt20">
                  <div>
                    <CustomButton text="Next" smallBtn onClick={handleNext} />
                  </div>
                </div>
              </div>
            ) : null}
            {activeStep === 1 ? (
              <Grid container spacing={2} className="flex-center">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Typography className="blue-color txt-semi-bold flex-center fs16">
                    Medications
                  </Typography>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <Card sx={card} className="mv20">
                    <div
                      className="flex-row-ali-cen cursor"
                      onClick={handlePresOpen}
                    >
                      {presOpen ? (
                        <ArrowDropDownIcon sx={icon} />
                      ) : (
                        <ArrowRightIcon sx={icon} />
                      )}
                      <div className="flex-row-ali-cen">
                        <Typography className="font-bold fs14 blue-color">
                          Prescription
                        </Typography>
                        <Typography className="font-bold fs14 gray20 ml5">
                          (optional)
                        </Typography>
                      </div>
                    </div>
                    {presOpen ? (
                      <div className="flex-column">
                        <div className="flex-row-ali-cen mh10">
                          <div className="w20Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Name
                            </Typography>
                          </div>
                          <div className="w15Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Qty
                            </Typography>
                          </div>
                          <div className="w10Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Dosage
                            </Typography>
                          </div>
                          <div className="w12Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Duration
                            </Typography>
                          </div>
                          <div className="w12Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Frequency
                            </Typography>
                          </div>
                          <div className="w12Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Instructions
                            </Typography>
                          </div>
                          <div className="w15Per">
                            <Typography className="txt-semi-bold fs12 blue-color">
                              Estimated Cost
                            </Typography>
                          </div>
                          <div className="w4Per" />
                        </div>
                        <div className="blue-hor-split mt5" />
                        {presList?.map((pr, ind) => {
                          return (
                            <div className="flex-row-ali-cen mt10 plan-bor">
                              <div className="w20Per pr10">
                                <CustomSelect
                                  list={getListBySelectedType()}
                                  value={pr?.name}
                                  addNewSelect
                                  mandatoryField
                                  handleChange={(e) => {
                                    handleChangePresValue(
                                      "name",
                                      e?.value ?? e,
                                      ind,
                                      {
                                        stockId: e?.stockId ?? null,
                                        productId: e?.productId ?? null,
                                        serviceId: e?.serviceId ?? null,
                                        type: e?.type,
                                      }
                                    );
                                  }}
                                  plusBtn
                                />
                              </div>
                              <div className="w15Per pr10">
                                <CustomTextField
                                  value={pr?.qty}
                                  handleChange={(e) =>
                                    handleChangePresValue(
                                      "qty",
                                      e?.target?.value,
                                      ind
                                    )
                                  }
                                  fullWidth
                                  type="number"
                                  endIcon
                                  inputIcon={
                                    getBatchList(pr?.stockId)?.[0]?.salesUom ??
                                    ""
                                  }
                                />
                              </div>
                              <div className="w10Per pr10">
                                <CustomTextField
                                  fullWidth
                                  handleChange={(e) =>
                                    handleChangePresValue(
                                      "dosage",
                                      e?.target?.value,
                                      ind
                                    )
                                  }
                                  value={pr?.dosage}
                                />
                              </div>
                              <div className="w12Per pr10">
                                <CustomTextField
                                  fullWidth
                                  handleChange={(e) =>
                                    handleChangePresValue(
                                      "duration",
                                      e?.target?.value,
                                      ind
                                    )
                                  }
                                  value={pr?.duration}
                                  endIcon
                                  inputIcon="days"
                                />
                              </div>
                              <div className="w12Per pr10">
                                {pr?.customFrequency ? (
                                  <CustomTextField
                                    fullWidth
                                    handleChange={(e) =>
                                      handleChangePresValue(
                                        "frequency",
                                        e?.target?.value,
                                        ind
                                      )
                                    }
                                    value={pr?.frequency}
                                  />
                                ) : (
                                  <CustomSelect
                                    list={frequncyCheckList}
                                    value={pr?.frequency ?? []}
                                    handleChange={(e) => {
                                      handleChangePresValue(
                                        "frequency",
                                        e?.target?.value,
                                        ind
                                      );
                                    }}
                                    multiSelectTagCheck
                                  />
                                )}
                              </div>
                              <div className="w12Per pr10">
                                <CustomSelect
                                  list={mealTypes}
                                  value={pr?.meal}
                                  select
                                  handleChange={(e) => {
                                    handleChangePresValue(
                                      "meal",
                                      e?.target?.value,
                                      ind
                                    );
                                  }}
                                />
                              </div>
                              <div className="w15Per">
                                <Typography className="txt-regular fs14 black18">
                                  Rs {pr?.cost ?? 0}
                                </Typography>
                              </div>
                              <div className="w4Per flex-center">
                                <img
                                  src={require("../../../assets/images/png/delete.png")}
                                  alt=""
                                  className="imghw30 ml10 cursor"
                                  onClick={() => deletePresByIndex(ind)}
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : null}
                    <div
                      className="flex-row-ali-cen mt10 cursor"
                      onClick={handleAddItem}
                    >
                      <div className="flex-center plus-icon">
                        <AddIcon sx={plusBtn} />
                      </div>
                      <Typography className="blue-color fs16 ml5 font-bold">
                        Add
                      </Typography>
                    </div>
                  </Card>
                  <div className="flex-end">
                    <div>
                      <CustomButton
                        text="Back"
                        smallBtn
                        grayBtn
                        onClick={handleBack}
                      />
                    </div>
                    <div className="ml20">
                      <CustomButton
                        text={presList?.length > 0 ? "Next" : "Skip"}
                        smallBtn
                        onClick={handleSkip}
                      />
                    </div>
                  </div>
                </Grid>
              </Grid>
            ) : null}
            {activeStep === 2 ? (
              <div>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="blue-color txt-semi-bold flex-center fs20">
                      Review & Submit
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Plan Name
                    </div>
                    <CustomTextField
                      value={planValues?.planName}
                      fullWidth
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">Species</div>
                    <CustomSelect
                      list={petTypes}
                      value={planValues?.species ?? []}
                      multiSelectTagCheck
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Service Type
                    </div>
                    <CustomSelect
                      list={planServiceTypes}
                      value={planValues?.serviceType}
                      select
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Consultation Type
                    </div>
                    <CustomSelect
                      list={typeList}
                      value={planValues?.consultationType ?? []}
                      multiSelectTagCheck
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">Type</div>
                    <CustomSelect
                      list={petAppntTypeList}
                      value={planValues?.type}
                      select
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Estimated Duration
                    </div>
                    <CustomTextField
                      fullWidth
                      value={planValues?.estimatedDuration}
                      endIcon
                      inputIcon={
                        planValues?.type === "Inpatient" ? "Days" : "Mins"
                      }
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <div className="txt-semi-bold fs14 blue-color">
                      Description
                    </div>
                    <CustomTextField
                      value={planValues?.description}
                      fullWidth
                      multiline
                      disabled
                    />
                  </Grid>
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <Typography className="flex-center fs20 txt-semi-bold blue-color">
                      Custom Treatment Protocol Form
                    </Typography>
                  </Grid>

                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    {questions?.map((ques, i) => (
                      <div key={`${ques?.question} ${i}`} className="mv5">
                        <Typography className="font-medium fs16 black">
                          {i + 1}) {ques?.question}
                        </Typography>
                        <div className="mv5">
                          {ques?.questionType === "shortAnswer" ||
                          ques?.questionType === "paragraph" ? (
                            <CustomTextField
                              fullWidth
                              value={ques?.answer}
                              disabled
                              multiline={ques?.questionType === "paragraph"}
                            />
                          ) : ques?.questionType === "multipleChoice" ||
                            ques?.questionType === "checkboxes" ? (
                            <div className="ml10">
                              {ques?.answers?.map((ans) => (
                                <div className="flex-row-ali-cen">
                                  <CustomCheckbox
                                    value={false}
                                    circle={
                                      ques?.questionType === "multipleChoice"
                                    }
                                    disabled
                                  />
                                  <Typography className="mlMin15 font-medium fs14 black">
                                    {ans}
                                  </Typography>
                                </div>
                              ))}
                            </div>
                          ) : (
                            <div>
                              {ques?.answers?.map((ans, i) => (
                                <div className="w15Per mv5" key={`ans ${i}`}>
                                  <CustomButton
                                    text="Upload File"
                                    smallBtn
                                    grayBtn
                                  />
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    ))}
                  </Grid>
                </Grid>
                <div className="flex-end">
                  <div>
                    <CustomButton
                      text="Back"
                      smallBtn
                      grayBtn
                      onClick={handleBack}
                    />
                  </div>

                  <div className="ml20">
                    <CustomButton
                      text="Submit"
                      smallBtn
                      onClick={handleSubmit}
                    />
                  </div>
                </div>
              </div>
            ) : null}
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default TreatmentPlanCreate;
